import { z } from 'zod';

/**
 * Optional free text: an empty box means "not provided", never an empty string.
 *
 * Shared by every form so the rule is the same everywhere: the stored document, the
 * receipt and the case description all treat a blank the same way.
 */
export function optionalText(max: number) {
  return z
    .string()
    .trim()
    .max(max, `Keep this under ${max} characters`)
    .transform((value) => (value === '' ? undefined : value))
    .optional();
}
